module.exports = __webpack_public_path__ + "img/tmp-nothing.be85d468.png";